export default {
  application: {
    title: 'MSTracker',
    exit: 'Sair',
    create: 'Criar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    close: 'Fechar',
    back: 'Voltar',
    save: 'Salvar',
    delete: 'Inativar',
    remove: 'Excluir',
    error: 'Erro',
    edit: 'Editar',
    yes: 'Sim',
    no: 'Não',
    actions: 'Ações',
    date: {
      long: 'Do MMMM, YYYY',
      short: 'DD/MM/YYYY',
    },
    languages: {
      pt_BR: 'Português',
      en: 'Inglês',
    },
    resend_email_pass: 'Reenviar e-mail de redefinição de senha',
    reset_pass: 'Redefinir Senha',
    errors_found_in: 'Erros encontrados em',
    errors_found: 'Erros encontrados',
    conclude: 'Concluir',
    recovery_pass: 'Recuperar senha',
    success: 'Sucesso',
    search: 'Buscar',
    message: 'Mensagem',
    clear_filter: 'limpar filtro',
    redirecting: 'Redirecionando',
    change_context: 'Alterar contexto',
    new: 'Novo',
    loading_theme: 'Carregando tema do programa, aguarde ...',
  },
  menu: {
    configuration: 'Configurações',
    notes: 'Notas',
    dashboard: 'Dashboard',
    company: 'Empresas',
    invoiceCheckout: 'Checkout de Notas',
    invoiceCreate: 'Inclusão de Notas',
    invoiceSearch: 'Localizar',
    workflowList: 'Fluxo de Atividades',
    users: 'Usuários',
    lotCreate: 'Inclusão de Lote',
    invoiceList: 'Consultar Todas as Notas',
    workflowSearch: 'Consulta de Fluxo',
    workflowExecution: 'Efetuar Execução',
  },
  fields: {
    active: 'Ativo',
    attachment: 'Anexo',
    cnpj: 'CNPJ',
    cpf: 'CPF',
    codeBar: 'Código de Barras',
    invoiceNumber: 'Número da nota',
    company: 'Empresa',
    email: 'Email',
    flow: 'Fluxo',
    login: 'Login',
    name: 'Nome',
    no_attachment: 'Nenhum arquivo anexado',
    password: 'Senha',
    phase: 'Fase',
    username: 'Usuário',
    user_type: 'Tipo de Usuário',
    workflow: 'Fluxo de Atividade',
    workflow_name: 'Nome do Fluxo de Atividade',
    expiration_time: 'Tempo de expiração',
    in_hours: 'Horas',

  },
  button: {
    create: 'Incluir',
    edit: 'Editar',
    delete: 'Excluir',
    cancel: 'Cancelar',
    back: 'Voltar',
    add: 'Adicionar',
    check: 'Checar',
    search: 'Buscar',
    view: 'Visualizar',
    login: 'Entrar',
    previous: 'Anterior',
    next: 'Próximo',
    finish: 'Finalizar',
    forgot_password: 'Esqueci a Senha',
    add_dynamic_fields: 'Adicionar campos dinâmicos',
    save: 'Salvar',
  },
  messages: {
    success_operation: 'Operação realizada com sucesso!',
    finished_session: 'Sessão finalizada com sucesso!',
    confirm_exit: 'Deseja realmente sair do sistema ?',
    confirm_delete: 'Deseja realmente inativar este registro ?',
    confirm_remove: 'Deseja realmente excluir este registro ?',
    confirm_workflow_incomplete: 'Este Fluxo de Atividade ainda não está concluído e será salvo como incompleto, deseja prosseguir a ação?',
    confirm_workflow_incomplete_message: 'Fluxos incompletos podem ser continuados quando se tenta iniciar um novo fluxo.',
    required_field: 'Este campo é obrigatório!',
    invalid_email: 'E-mail inválido!',
    invalid_cpf: 'Número de CPF inválido!',
    invalid_cnpj: 'Número de CNPJ inválido!',
    loading_data: 'Carregando dados, aguarde ...',
    saving_data: 'Salvando registro, aguarde ...',
    deleting_data: 'Inativando registro, aguarde ...',
    removing_data: 'Excluindo registro, aguarde ...',
    success_delete_data: 'Registro inativado!',
    password_not_equals: 'A confirmação de senha, não confere!',
    changing_pass: 'Alterando senha ...',
    ask_forgot_pass: 'Esqueceu sua senha ?',
    account_not_exists: 'E-mail não encontrado',
    recovery_email_has_been_sent: 'Em instantes você receberá um e-mail com link para alteração da senha.',
    success_change_password: 'A senha foi alterada com sucesso!',
    error_change_password: 'A senha não foi alterada!',
    activating_data: 'Ativando registro ...',
    inactivating_data: 'Inativando registro ...',
    blocking_data: 'Bloquando registro ...',
    unblocking_data: 'Desbloqueando registro ...',
    standby_data: 'Salvando informações de standby ...',
    unexpected_error: 'Ocorreu um erro inesperado',
    invalid_less_date: 'O valor da data de %{field} deve ser maior que %{date}',
    invalid_less_than: 'Deve ser maior que %{value}',
    invalid_more_than: 'Deve ser menor que %{value}',
    invalid_minimum_than: 'Deve ser pelo menos %{value}',
    invalid_min_character: 'Deve ter mais que %{value} caracter(es)',
    invalid_max_character: 'Não deve ter mais que %{value} caracter(es)',
    choose_one_option: 'Selecione pelo menos uma opção em "%{field}"',
    loading: 'Carregando ...',
    error_image_size: 'Arquivo não pode ser maior que 1024KB',
    empty: 'Nenhum registro encontrado',
    no_items_selected: 'Nenhum item foi selecionado.',
    document_sent: 'Documento enviado!',
    invalid_time_format: 'Valor de hora/minuto inválido.',
    invalid_time_more_than: 'O valor da hora inicial não pode ser maior que o valor da hora final.',
  },
  permissions: {
    write: 'Gravar',
    list: 'Visualizar',
    remove: 'Excluir',
    change: 'Alterar Senha',
    change_password: 'Alterar Senha',
    activate: 'Ativar',
    standby: 'StandBy',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    inactivate: 'Inativar',
    actions: 'Ações',
  },
  tableList: {

    // for filter panel
    page: 'Página',
    more: 'Mais',
    to: 'até',
    of: 'de',
    next: 'Próxima',
    last: 'Última',
    first: 'Primeira',
    previous: 'Anterior',
    loadingOoo: 'Carregando ...',
    showing: 'Exibindo',

    // for set filter
    selectAll: 'Selecionar todos',
    searchOoo: 'Procurando ...',
    blanks: 'Espaços em Branco',

    // for number filter and text filter
    filterOoo: 'Busca',
    applyFilter: 'Filtrar',

    // for number filter
    equals: 'Igual',
    lessThan: 'Menor que',
    greaterThan: 'Maior que',
    lessOrEqual: 'Menor ou Igual',
    greaterOrEqual: 'Maior ou Igual',

    // for text filter
    contains: 'Contém',
    notEquals: 'Diferente',
    notContains: 'Não contém',
    notContain: 'Não contém',
    startsWith: 'Começa com',
    endsWith: 'Termina com',

    // the header of the default group column
    group: 'Grupo',

    // tool panel
    columns: 'Colunas',
    rowGroupColumns: 'Colunas Pivot',
    rowGroupColumnsEmptyMessage: ' Arraste as colunas para agrupar',
    valueColumns: 'Valor das Colunas',
    pivotMode: 'Modo Pivot',
    groups: 'Grupos',
    values: 'Valores',
    pivots: 'Pivôs',
    valueColumnsEmptyMessage: ' arraste colunas para adicionar',
    pivotColumnsEmptyMessage: ' arraste até aqui para pivô',

    // other
    noRowsToShow: ' Não há registros para exibir',

    // enterprise menu
    pinColumn: 'Coluna Alfinete',
    valueAggregation: 'Valor add',
    autosizeThiscolumn: 'Autosize Diz',
    autosizeAllColumns: 'Autsoie em All',
    groupBy: 'Agrupar por',
    ungroupBy: 'Desagrupar por',
    resetColumns: 'Resetar estas colunas',
    expandAll: 'Open-em-up',
    collapseAll: 'Close-em-up',
    toolPanel: 'Tool Panelo',

    // enterprise menu pinning
    pinLeft: 'Pin <<',
    pinRight: 'Pin >>',
    noPin: 'DontPin <>',

    // enterprise menu aggregation and status panel
    sum: 'Somar',
    min: 'Mínimo',
    max: 'Máximo',
    none: 'Não',
    count: 'Total',
    average: 'Média',

    // standard menu
    copy: 'Copiar',
    copyWithHeaders: 'Copiar com cabeçalhos',
    ctrlC: 'ctrl n C',
    paste: 'Paste',
    ctrlV: 'ctrl n C',
  },
  titles: {
    create: 'Inclusão de ',
    edit: 'Edição de ',
    delete: 'Remoção de',
    new_workflow: 'Incluir novo Fluxo de Atividade',
    phase_creation: 'Criar Fases',
    uncompleted_workflow: 'Fluxos Incompletos',
    company: 'Empresa',
    account: 'Usuário',
    lotInsert: 'Inserir notas em Lote',
    invoice: 'Nota',
    invoiceList: 'Consulta de Notas',
    findInvoice: 'Localizar Nota',

  },
  research: {
    tabs: {
      research: 'Pesquisa',
      avaliation: 'Avaliação',
      questionsAnswers: 'Perguntas e respostas',
    },
    answer: {
      results: 'Resultados',
      minimumWeight: 'De',
      maximumWeight: 'Até',
      value: 'Valor',
      resultResearch: 'Resultado da pesquisa',
    },
    question: {
      researchId: 'ID Pesquisa',
      research: 'Pesquisa',
      text: 'Pergunta',
      type: 'Tipo da resposta',
      type_dissertative: 'Dissertativa',
      type_multiple_choice: 'Múltipla escolha',
      type_only_choice: 'Única escolha',
      order: 'Ordem',
      textType: 'Tipo de texto',
      textType_text: 'Texto',
      textType_date: 'Data',
      textType_integer: 'Inteiro',
      textType_decimal: 'Decimal',
      responses: 'Respostas',
    },
    responseQuestions: {

      questionId: 'ID Pergunta',
      question: 'Pergunta',
      text: 'Resposta',
      weight: 'Peso',
      order: 'Ordem de exibição',
      nextQuestionId: 'Próxima pergunta',
    },
  },

  enums: {
    userType: {
      1: 'Administrador',
      2: 'Operador',
    }
  },
  workflow: {
    tasks: {
      recurrenceModel: 'Recorrencia',
      types: {
        Start: 'Início',
        Simple: 'Simples',
        Scheduled: 'Agendada',
        Condition: 'Condicional',
        Recurrence: 'Recorrente',
        Finished: 'Finalização',
        Workflow: 'Fluxo',
      },
    },
    recurrences: {
      types: {
        daily: 'Daily',
        monthly: 'Monthly',
        yearly: 'Yearly',
      },
    },
    resourceModels: {
      types: {
        manual: 'Manual',
        automatic: 'Automático',
      },
    },
    segments: {
      types: {
        success: 'Sucesso',
        fail: 'Falha',
        retry: 'Tentar novamente',
        expiration: 'Expirado',
        condition: 'Condicional',
      },
    },
  },

};



// WEBPACK FOOTER //
// ./src/i18n/pt_BR.js